import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../Context/AuthContext/AuthContext'
import { ThemeContext } from '../Context/ThemeContext/ThemeContext'

// import './SignUp.css'

const Login = () => {
  const history = useHistory()
  const { isLight } = useContext(ThemeContext)
  const {logIn} = useContext(AuthContext)

  const [email,setEmail] = useState('')
  const [password, setPassword] = useState('')


  
  const sign = () =>{
    logIn(email,password)
      .then(() => {
        setEmail('')
        setPassword('')
        history.push('/')
      })
  }

  const handleSubmit = e => {
    e.preventDefault()
    sign()
  }


  return (
    <section className={`signup ${isLight ? "" : "dark"}`} onSubmit={handleSubmit}>
      <div className="signup__container">
        <form className="signup__form">
          <h2>Login</h2>
          <div className="signup__input__container">
            <input type="text" required value={email} onChange={e => setEmail(e.target.value)}/>
            <label>Email</label>
          </div>
          <div className="signup__input__container">
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}/>
            <label>Password</label>
          </div>

          <button className="signup__btn" type="submit">Login</button>
        </form>
      </div>
    </section>
  )
}

export default Login
